import React from 'react';

// Added to both sides before taking the share: weak readings (meter noise)
// barely move the bar, while a sustained spell still pushes it wide.
const PRESSURE_SMOOTHING = 0.75;

// Keep both ends visible even in a completely one-sided spell.
const clampShare = (value) => Math.max(8, Math.min(92, value));

export const getPressureShare = (pressure) => {
    const home = Number(pressure?.home);
    const away = Number(pressure?.away);
    if (!Number.isFinite(home) || !Number.isFinite(away)) return 50;

    const safeHome = Math.max(home, 0);
    const safeAway = Math.max(away, 0);
    const share = (safeHome + PRESSURE_SMOOTHING) /
        (safeHome + safeAway + PRESSURE_SMOOTHING * 2);
    return clampShare(share * 100);
};

/**
 * Live tug-of-war strip fed by the engine's pressure meters (0 to 10 per
 * team). Sits where the event timeline used to live; pressure only means
 * something while the match runs, so it renders nothing otherwise.
 */
function MatchPressureBar({ pressure = null, isLive = false }) {
    if (!isLive) return null;

    const homeShare = getPressureShare(pressure);
    const roundedHome = Math.round(homeShare);

    return (
        <div
            className="mx-pressure"
            data-testid="match-pressure-bar"
            aria-label={`Live pressure: home ${roundedHome}%, away ${100 - roundedHome}%`}
        >
            <span className="mx-pressure__label">Pressure</span>
            <span className="mx-pressure__bar" aria-hidden="true">
                <span className="mx-pressure__home" style={{ width: `${homeShare}%` }} />
                <span className="mx-pressure__away" />
                <span className="mx-pressure__tick" />
            </span>
        </div>
    );
}

export default MatchPressureBar;
